import React from "react";
import { ButtonContent, ButtonLoading, IconButton, LinkButton, PrimaryButton } from "./styles";
import editIcon from "assets/images/edit.svg";

export default function Button({ variant, onClick, style, disabled, type = "button", children, isLoading, }) {
	const buttonProps = {
		onClick,
		style,
		disabled,
		type,
	}
	switch (variant) {
		case "edit": {
			return (
				<IconButton {...buttonProps}>
					<img src={editIcon} alt="edit" />
				</IconButton>
			)
		}
		case "icon": {
			return (
				<IconButton {...buttonProps}>{children}</IconButton>
			)
		}
		case "link": {
			return (
				<LinkButton variant="link" {...buttonProps}>
					{children}
				</LinkButton>
			)
		}
		case "primary":
		default: {
			return (
				<PrimaryButton variant="outline-dark" {...buttonProps}>
					<ButtonContent>
						{isLoading && (
							<ButtonLoading>
								<div className="loader"></div>
							</ButtonLoading>
						)}
						{children}
					</ButtonContent>
				</PrimaryButton>
			)
		}
	}

}
